import { Badge } from '@material-ui/core';
import {
  AvatarButton,
  AvatarButtonProps,
  ColorDynamic,
  useSnackbarStack,
} from '@superdispatch/ui';
import { useMemo } from 'react';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { MediaUploadWrapper } from 'shared/form/MediaUploadWrapper';
import { CameraOutlinedIcon } from 'shared/icons/CameraOutlinedIcon';
import { useCarrierInfo } from 'shared/modules/carrier-profile/data/CarrierInfoAPI';
import { useCarrierSettings } from 'shared/settings/CarrierSettingsAPI';
import { getInitials } from 'shared/utils/TextUtils';
import { useCarrierProfileAPI } from '../data/CarrierProfileAPI';

export function CarrierInfoAvatar(props: Omit<AvatarButtonProps, 'src'>) {
  const { addSnackbar } = useSnackbarStack();
  const { data: settings } = useCarrierSettings();
  const { data: carrierInfo } = useCarrierInfo();
  const { updateCarrierInfo } = useCarrierProfileAPI();

  const isEditingDisabled =
    !settings?.drivers_can_edit_carrier_info && MobileAppBridge.isInjected();

  const companyNameInitials = useMemo(
    () => carrierInfo?.name && getInitials(carrierInfo.name),
    [carrierInfo?.name],
  );

  return (
    <MediaUploadWrapper
      onChange={(url) => {
        if (carrierInfo) {
          void updateCarrierInfo({ ...carrierInfo, logo_url: url });
        }
      }}
      onError={(error) => {
        addSnackbar(error, { variant: 'error' });
      }}
    >
      <Badge
        badgeContent={<CameraOutlinedIcon htmlColor={ColorDynamic.Dark100} />}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        overlap="circular"
      >
        <AvatarButton
          {...props}
          disabled={isEditingDisabled}
          src={carrierInfo?.logo_url}
        >
          {companyNameInitials}
        </AvatarButton>
      </Badge>
    </MediaUploadWrapper>
  );
}
